module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/general/half-star-85a97edb6992ba3bf0b095ea9f9eedc8.svg";